import { useState, useEffect, Fragment } from 'react';
import './ProgressBar.css';
const ProgressBar = ({ value, maxValue, className }) => {
	return <progress value={value || 0} max={maxValue} className={className || ''} />;
};

export default ProgressBar;
